var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper,style:(_vm.objectStyle),attrs:{"id":"target1"}},[_vm._v(_vm._s(_vm.text || _vm.item.value))])}
var staticRenderFns = []

export { render, staticRenderFns }